// C.1 — реестр триггеров «карта-Мод разыграна на союзника» для Синтетика.
//
// Расширяет attachMod в modifications.js (через явный экспорт fireOnModPlayed).
// Используется юнитами Синтетика с DSL-триггером event=mod_played.
//
// API:
//   registerOnModPlayedTrigger(cardId, fn) — fn(state, observer, target).
//   fireOnModPlayed(state, target, source) — вызывается из attachMod.
//     source.isPlayed=true означает «разыграна карта-Мод из руки», иначе —
//     триггер-источник (Раст, Нарколаб) — fn НЕ зовётся.

import { registerImplementedAbility } from '../../warn-unimplemented.js';
import { applyPermanentBuff } from '../../../buffs.js';
import { healUnit } from '../../livlife/heal.js';
import { applyDamage } from '../../../combat.js';

const _triggers = new Map();

export function registerOnModPlayedTrigger(cardId, fn) {
  if (typeof cardId !== 'string' || typeof fn !== 'function') return;
  _triggers.set(cardId, fn);
}

export function fireOnModPlayed(state, target, source) {
  if (!state?.players) return;
  if (!target) return;
  // Только при isPlayed=true (карта-Мод из руки, не триггер-источник).
  if (!source?.isPlayed) return;
  const ownerIdx = target.ownerId;
  const owner = state.players[ownerIdx];
  if (!owner?.field) return;
  for (const row of owner.field) for (const u of row || []) {
    if (!u || !u.isAlive || !u.isAlive()) continue;
    if (u.current?.silenced) continue;
    const fn = _triggers.get(u.id);
    if (!fn) continue;
    try { fn(state, u, target); } catch (e) {
      console.warn(`[Корпы] mod_played trigger ${u.id} упал:`, e);
    }
  }
}

// === syn_doctor_shram — mod_played → +0/1/0 hero_self perm ===
registerOnModPlayedTrigger('syn_doctor_shram', (state, observer) => {
  const hero = state.players?.[observer.ownerId]?.hero;
  if (!hero) return;
  hero.base.armor += 1;
  hero.persistentMaxArmor = (hero.persistentMaxArmor || 0) + 1;
  hero.persistentArmor = (hero.persistentArmor || 0) + 1;
  if (hero.current) hero.current.armor += 1;
});
registerImplementedAbility('syn_doctor_shram', 'trigger');

// === syn_bishor_lich — mod_played → +1/0/0 self perm ===
registerOnModPlayedTrigger('syn_bishor_lich', (state, observer) => {
  applyPermanentBuff(state, observer, { atk: 1, armor: 0, hp: 0 }, observer.id, observer.name_ru);
});
registerImplementedAbility('syn_bishor_lich', 'trigger');

// === syn_implantolog — mod_played → heal 2 hero_self ===
registerOnModPlayedTrigger('syn_implantolog', (state, observer) => {
  const hero = state.players?.[observer.ownerId]?.hero;
  if (hero) healUnit(state, hero, 2, observer);
});
registerImplementedAbility('syn_implantolog', 'trigger');

// === syn_implantoman — mod_played → +1/0/0 self perm ===
registerOnModPlayedTrigger('syn_implantoman', (state, observer) => {
  applyPermanentBuff(state, observer, { atk: 1, armor: 0, hp: 0 }, observer.id, observer.name_ru);
});
registerImplementedAbility('syn_implantoman', 'trigger');

// === syn_bioenginer — mod_played → draw 1 self_owner ===
registerOnModPlayedTrigger('syn_bioenginer', (state, observer) => {
  const owner = state.players?.[observer.ownerId];
  if (owner?.deck?.length > 0 && owner.hand.length < 10) {
    owner.hand.push(owner.deck.shift());
  }
});
registerImplementedAbility('syn_bioenginer', 'trigger');

// === syn_hirurg_bez_litsenzii — уже реализован через hirurgOnModPlayed в
// modifications.js → hirurg.js (не дублируем).
registerImplementedAbility('syn_hirurg_bez_litsenzii', 'trigger');
